import { createSlice } from "@reduxjs/toolkit"

// The settings document, centers list, and loading state all live in the
// React Query cache (see useFetchSettings / useFetchCenters). This slice
// only holds the user's currently-selected center, which is UI state that
// drives location filters across pages.
const settingsSlice = createSlice({
	name: "settings",
	initialState: {
		center: null
	},
	reducers: {
		setCenter: (state, action) => {
			state.center = action.payload
		}
	}
})

export const { setCenter } = settingsSlice.actions

export default settingsSlice.reducer
